export default "__VITE_ASSET__BMu12Pxj__"